import { useQuery } from "@apollo/react-hooks";
import React from "react";
import { GET_ORDER_PREVIEW_IMAGE } from "../../../graphql/queries";
import { get } from "lodash";
import { Heading } from "@shopify/polaris";

export default function ShowOrderPreviewImage({ originID, lineID }) {
    const { data } = useQuery(GET_ORDER_PREVIEW_IMAGE, {
        variables: {
            input: originID ? [{ originID, lineID }] : undefined,
        },
        skip: !originID,
    });

    const previewImage = getPreview(data, originID, lineID);

    const imgItemStyle = {
        maxWidth: "100%",
        objectFit: "cover",
        borderRadius: 3,
        boxShadow:
            "rgba(0, 0, 0, 0.1) 0px -1px 15px -3px, rgba(0, 0, 0, 0.1) 0px 4px 6px 2px",
    };

    return (
        <div>
            {previewImage ? (
                <>
                    <Heading element="h3">Preview Image:</Heading>
                    <img
                        className={"cursor-pointer block"}
                        src={previewImage}
                        alt={"product mockup"}
                        style={{
                            ...imgItemStyle,
                        }}
                    />
                </>
            ) : null}
        </div>
    );
}

function getPreview(data, originId, lineID) {
    const obj = get(data, "getOrderPreviewImage") || {};

    let key = originId;
    if ((lineID || "").length > 0) {
        key += "_" + lineID;
    }
    return obj && typeof obj === "object" ? obj[key] : "";
}
